import { useFlags } from 'launchdarkly-react-client-sdk'
import { FC, useEffect, useState } from 'react'
import { styled } from '../../../lib/stitches'
import Tabs from '../../platform/new-explore/components/Tabs'
import { SearchContext } from '../new-explore/hooks/useSearch'
import CompetitionTable from './CompetitionTable'
import Header from './Header'

const CompetitionPageContainer = styled('div', {
  background: '$background__primary'
})

const CompetitionPage: FC = () => {
  const flags = useFlags()
  useEffect(() => {
    document.title = 'Competition Entries'
  }, [])

  const [search, setSearch] = useState<string>('')

  if (flags.competitionPageLive) {
    return (
      <CompetitionPageContainer>
        <Header />
        <SearchContext.Provider value={[search, setSearch]}>
          <Tabs.Root defaultValue="songs">
            <Tabs.Content value="songs">
              <CompetitionTable top="86px" />
            </Tabs.Content>
          </Tabs.Root>
        </SearchContext.Provider>
      </CompetitionPageContainer>
    )
  }
}
export default CompetitionPage
